import { useContext } from 'react';

import { BusinessDataContext } from '@/context';

export const useBusinessData = () => {
  return useContext(BusinessDataContext);
};
